// Mapbox config - uses environment variables
export const MAPBOX_TOKEN: string = process.env.REACT_APP_MAPBOX_TOKEN || '';
export const MAPBOX_STYLE: string = process.env.REACT_APP_MAPBOX_STYLE || '';
